import { render, staticRenderFns } from "./genre-filter-pills.vue?vue&type=template&id=694b138d&scoped=true"
import script from "./genre-filter-pills.vue?vue&type=script&setup=true&lang=js"
export * from "./genre-filter-pills.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre-filter-pills.vue?vue&type=style&index=0&id=694b138d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694b138d",
  null
  
)

export default component.exports